import { Link } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { Paragraph } from "../ui/typography/Paragraph";
import { ParagraphBold } from "../ui/typography/ParagraphBold";

interface SectionRouteProps {
  route_one?: ReactNode;
  route_one_link?: string;
  route_two?: ReactNode;
  route_two_link?: string;
  route_three?: ReactNode;
  route_three_link?: string;
  route_four?: ReactNode;
}

const SectionRoute: React.FC<SectionRouteProps> = ({
  route_one = "Dashboard",
  route_two = "Home",
  route_three = "",
  route_one_link = "/dashboard",
  route_two_link,
  route_three_link,
  route_four,
}) => {
  const renderRoute = (route: ReactNode) =>
    typeof route === "string" ? <Paragraph>{route}</Paragraph> : route;
  const renderCurrentRoute = (route: ReactNode) =>
    typeof route === "string" ? <ParagraphBold>{route}</ParagraphBold> : route;

  return (
    <div className="flex items-center space-x-2 mb-4">
      <Link
        to={route_one_link}
        className="hover:underline hover:underline-offset-4"
      >
        {renderRoute(route_one)}
      </Link>
      <span className="text-neutral-400">{">"}</span>
      {!route_three ? (
        renderCurrentRoute(route_two)
      ) : (
        <Link
          to={route_two_link}
          className="hover:underline hover:underline-offset-4"
        >
          {renderRoute(route_two)}
        </Link>
      )}
      {route_three && (
        <>
          <span className="text-neutral-500">{">"}</span>
          {route_four ? (
            <>
              <Link
                to={route_three_link}
                className="hover:underline hover:underline-offset-4"
              >
                {renderRoute(route_three)}
              </Link>
              <span className="text-neutral-400">{">"}</span>
            </>
          ) : (
            renderCurrentRoute(route_three)
          )}
        </>
      )}
      {route_four && renderCurrentRoute(route_four)}
    </div>
  );
};

export { SectionRoute };
